import React from "react";
import Table from "components/UI/Table";
import SkeletonLine from "components/UI/Skeleton/SkeletonLine";
import range from "lodash.range";

const SkeletonWorkList = props => {
  return (
    <Table {...props}>
      <Table.Thead>
        <Table.Tr>
          {range(7).map(i => (
            <Table.Th key={i}>
              <SkeletonLine />
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {range(8).map(i => (
          <Table.Tr key={i}>
            {range(7).map(i => (
              <Table.Td key={i}>
                <SkeletonLine />
              </Table.Td>
            ))}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};

export default SkeletonWorkList;
